import modal from "components/Modal/ModalContent.module.css";
import styles from "./ScheduleExecutionUpsellModalContent.module.css";
import cn from "classnames";
import { Button } from "components/Button/Button";
import { AnchorButton } from "components/Button/AnchorButton";

import { useAnalytics } from "gui/analytics/analytics";

interface Props {
  close: () => void;
}

export function ScheduleExecutionUpsellModalContent(props: Props) {
  const analytics = useAnalytics();

  function onCloseClick() {
    analytics.captureEvent("Refresh query upsell modal: Close button clicked");
    props.close();
  }
  function onMigrateLinkClick() {
    analytics.captureEvent("Refresh query upsell modal: Migrate link clicked");
  }

  return (
    <div className={cn(modal.body)}>
      <img
        src="/assets/schedule-and-execute-queries-programmatically.gif"
        className={styles.image}
      />

      <div className={modal.header}>
        <div className={modal.titleRow}>
          <h2>
            Migrate your account to our new subscription plans to use query
            schedule.{" "}
          </h2>
        </div>

        <div className={modal.description}>
          With our new subscription plans you can set run queries automatically
          by setting the time and day for them to run. Migrate plan and:
          <ul className={styles.list}>
            <li>Use credits flexibly across the Dune App and API;</li>
            <li>Build with our API included in every plan;</li>
            <li>Optimize query executions with performance selection;</li>
            <li>Collaborate with anyone with unlimited free teammate;</li>
          </ul>
        </div>
      </div>

      <div className={modal.buttons}>
        <Button size="M" theme="tertiary" onClick={onCloseClick}>
          Close
        </Button>

        <AnchorButton
          size="M"
          theme="primary"
          href="/subscription/migrate"
          // Left click
          onClickCapture={onMigrateLinkClick}
          // Middle mouse button click
          onAuxClick={onMigrateLinkClick}
        >
          Continue
        </AnchorButton>
      </div>
    </div>
  );
}
